import React from 'react'
import ReactModal from 'react-modal'
import './modal.scss'
function Modal({
    isOpen,
    onRequestClose,
    onAfterOpen,
    headerTitle,
    children
}) {
    const dimension = {
        width: window.innerWidth,
        height: window.innerHeight
    }
    const customStyles = {
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: dimension.width > 768 ? '50%' : '90%',
            borderRadius: '10px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
            border: 'none'
        }
    }
    return (
        <ReactModal isOpen={isOpen} onRequestClose={onRequestClose} contentLabel={headerTitle} style={customStyles} onAfterOpen={onAfterOpen}>

            <header className='d-flex justify-content-between align-items-start gap-2 border-bottom pb-2 mb-2'>
                <h5 className='mb-0'>{headerTitle}</h5>
                <button type="button" className="btn btn-outline-secondary btn-app btn-app--icon flex-shrink-0" aria-label="Kapat" title="Kapat" onClick={onRequestClose}>
                    <i className="bi bi-x-lg" aria-hidden="true"></i>
                </button>
            </header>

            <main className='my-3'>
                {children}
            </main>

        </ReactModal>
    )
}

ReactModal.setAppElement('#root')

export default Modal